import { all, takeEvery, takeLatest } from 'redux-saga/effects';

import { handleRequest } from '@sagas/request';
import {
  polishSkuRequest,
  polishSkuUpdateRequest,
  polishSkuDeleteAllRequest,
  polishSkuDownloadTemplateRequest,
  polishSkuUploadTemplateRequest,
} from '@store/polishSku';

export default all([
  takeLatest(polishSkuRequest.type, handleRequest),
  takeEvery(polishSkuUpdateRequest.type, handleRequest),
  takeEvery(polishSkuDeleteAllRequest.type, handleRequest),
  takeLatest(polishSkuDownloadTemplateRequest.type, handleRequest),
  takeLatest(polishSkuUploadTemplateRequest.type, handleRequest),
]);
